module.exports = __webpack_public_path__ + "static/media/Logo_ISN.85d90e4e.svg";